import { IsAllow, PlanTypes, SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import SwitchSuccess from './switch-success';

export enum SwitchPaths {
    Switch = '/switch',
    SwitchTo = '/switch/to',
    SwitchChangeRequest = '/switch/change',
    SwitchOtp = '/switch/otp',
    SwitchSuccess = '/switch/success',
}

export type SwitchFlowType = {
    switchFromScheme: SCHEMES_RESPONSE;
    data?: SCHEMES_RESPONSE[];
    switchToScheme: SCHEMES_RESPONSE & { plan: PlanTypes; brokerCode?: string };
};

export type SwitchApiRequestSchemeOptionsType = {
    itemNo: string;
    folio: string;
    fromIsin: string;
    toIsin: string;
    reInvest: string;
    amount: string;
    units: string;
    allUnits: string;
    trxnDate: string;
    trxnTime: string;
    userTrxnNo: string;
    distId: string;
    subDist: string;
    subBrokerARN: string;
    euin: string;
    euinDeclarationFlag: string;
    riaCode: string;
};

export enum OTPACTION {
    SWITCH = 'SWITCH',
}

export type SwitchApiDataKeyType = {
    amc: string;
    schemeOptions: [SwitchApiRequestSchemeOptionsType];
    dpid: string;
    source: 'web' | 'mobile';
};

export type SwitchAPIRequestType = {
    reqId: string;
    pan: string;
    mobile: string;
    email: string;
    pekrn: string;
    data: [SwitchApiDataKeyType];
};

export enum InvestThrough {
    arn,
    ria,
    direct,
}

export type SwitchSelectTo<T> = {
    categories: T[];
    amcs: T[];
    planMode: T[];
    minimumInvestment: T[];
};

export enum MAX_LENGTHS {
    ARN_LENGTH = 16,
    SUB_BROKER_LENGTH = 30,
    SUB_BROKER_ARN_LENGTH = 30,
    RIA_LENGTH = 9,
    EUIN_LENGTH = 6,
}

export enum MIN_LENGHTHS {
    ARN_LENGTH = 4,
}

type ARNType = string;

export type InvestModePayLoadType = {
    distId: ARNType;
    subBrokerARN: ARNType;
    subDist: ARNType;
    euin: string;
    euinDeclarationFlag: IsAllow | string;
    riaCode: string;
    investThrough: InvestThrough | null;
    euinCheck: IsAllow | null;
    riaFlag: string;
};
